// extracted by mini-css-extract-plugin
export default {"cardContainer":"TransformCard_cardContainer__bW84W","hoverable":"TransformCard_hoverable__ttoIv"};